function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { MoveAngle } from "./MoveAngle";
import { MoveAttract } from "./MoveAttract";
import { MoveCenter } from "./MoveCenter";
import { MoveGravity } from "./MoveGravity";
import { MovePath } from "./Path/MovePath";
import { MoveTrail } from "./MoveTrail";
import { OutModes } from "./OutModes";
import { Spin } from "./Spin";
import { setRangeValue } from "../../../../Utils/NumberUtils";
export var Move = /*#__PURE__*/function () {
  function Move() {
    _classCallCheck(this, Move);

    this.angle = new MoveAngle();
    this.attract = new MoveAttract();
    this.center = new MoveCenter();
    this.decay = 0;
    this.distance = {};
    this.direction = "none";
    this.drift = 0;
    this.enable = false;
    this.gravity = new MoveGravity();
    this.path = new MovePath();
    this.outModes = new OutModes();
    this.random = false;
    this.size = false;
    this.speed = 2;
    this.spin = new Spin();
    this.straight = false;
    this.trail = new MoveTrail();
    this.vibrate = false;
    this.warp = false;
  }

  _createClass(Move, [{
    key: "bounce",
    get: function get() {
      return this.collisions;
    },
    set: function set(value) {
      this.collisions = value;
    }
  }, {
    key: "collisions",
    get: function get() {
      return false;
    },
    set: function set(_) {}
  }, {
    key: "noise",
    get: function get() {
      return this.path;
    },
    set: function set(value) {
      this.path = value;
    }
  }, {
    key: "outMode",
    get: function get() {
      return this.outModes.default;
    },
    set: function set(value) {
      this.outModes.default = value;
    }
  }, {
    key: "out_mode",
    get: function get() {
      return this.outMode;
    },
    set: function set(value) {
      this.outMode = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _a, _b, _c;

      if (!data) {
        return;
      }

      this.angle.load(typeof data.angle === "number" ? {
        value: data.angle
      } : data.angle);
      this.attract.load(data.attract);
      this.center.load(data.center);

      if (data.decay !== undefined) {
        this.decay = setRangeValue(data.decay);
      }

      if (data.direction !== undefined) {
        this.direction = data.direction;
      }

      if (data.distance !== undefined) {
        this.distance = typeof data.distance === "number" ? {
          horizontal: data.distance,
          vertical: data.distance
        } : Object.assign({}, data.distance);
      }

      if (data.drift !== undefined) {
        this.drift = setRangeValue(data.drift);
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      this.gravity.load(data.gravity);
      var outModes = (_b = (_a = data.outModes) !== null && _a !== void 0 ? _a : data.outMode) !== null && _b !== void 0 ? _b : data.out_mode;

      if (outModes !== undefined) {
        if (_typeof(outModes) === "object") {
          this.outModes.load(outModes);
        } else {
          this.outModes.load({
            default: outModes
          });
        }
      }

      this.path.load((_c = data.path) !== null && _c !== void 0 ? _c : data.noise);

      if (data.random !== undefined) {
        this.random = data.random;
      }

      if (data.size !== undefined) {
        this.size = data.size;
      }

      if (data.speed !== undefined) {
        this.speed = setRangeValue(data.speed);
      }

      this.spin.load(data.spin);

      if (data.straight !== undefined) {
        this.straight = data.straight;
      }

      this.trail.load(data.trail);

      if (data.vibrate !== undefined) {
        this.vibrate = data.vibrate;
      }

      if (data.warp !== undefined) {
        this.warp = data.warp;
      }
    }
  }]);

  return Move;
}();